<template>
  <div class="filter-facet-selector">
    <h3 class="h3-bold filter-facet-selector__title">
      {{ tStatic('otherFilters') }}
    </h3>
    <div class="filter-facet-selector__sections">
      <oie-expandable-item
        v-for="facet in sortedFacets()"
        :key="facet.name"
        :heading="`${facet.name} (${facet.specificationFilterCategories.length})`"
        theme="tertiary"
        :open-on-init="openOnInit">
        <template v-slot:icon="{ isOpen }">
          <oie-use-svg
            svg="circle-plus"
            :class="{'svg--45': isOpen}"
            height="25"
            width="25"></oie-use-svg>
        </template>
        <div v-for="specCategory in facet.specificationFilterCategories" :key="`${facet.name}__${specCategory.name}`">
          <h5 class="filter-facet-selector__section-sub-title">
            {{ specCategory.name }}
          </h5>
          <div class="filter-facet-selector__section-filters">
            <template v-for="specField in specCategory.specificationFilterFields">
              <template v-if="specField.distinctValues">
                <oie-expandable-item
                  :key="specField.id"
                  :heading="getHeadingText(specField)"
                  theme="primary">
                  <template v-slot:icon="{ isOpen }">
                    <oie-use-svg
                      svg="chevron-down"
                      :class="[{'svg--180-negative': isOpen}]"
                      :width="13"
                      :height="7"
                      :options="{ strokeWidth: 1 }"></oie-use-svg>
                  </template>
                  <oie-base-checkbox
                    v-for="value in specField.distinctValues"
                    :key="`${specField.id}__${value.value}`"
                    :value="state.selectableFacets[specField.id].distinctValues"
                    :is-for="`${specField.id}__${value.value}`"
                    :text="getCheckboxText(specField, value)"
                    :val="value.value"
                    :size="'small'"
                    @input="handleFacetSelection($event, specField.id, 'distinctValues')"></oie-base-checkbox>
                </oie-expandable-item>
              </template>
              <oie-base-slider
                v-else
                :key="specField.id"
                :title="`${specField.name} (${specField.unit})`"
                :selected-values="state.selectableFacets[specField.id].userSelection"
                :min="Math.floor(state.selectableFacets[specField.id].currentMinMax[0])"
                :max="Math.ceil(state.selectableFacets[specField.id].currentMinMax[1])"
                @input="handleFacetSelection($event, specField.id, 'userSelection')"></oie-base-slider>
            </template>
          </div>
        </div>
      </oie-expandable-item>
    </div>
  </div>
</template>

<script>
import { state, sortedFacets, FILTER_TYPES } from '@/store/filters'

export default {
  data() {
    return {
      state,
      sortedFacets
    }
  },
  computed: {
    openOnInit() {
      return sortedFacets().length < state.accordionsThreshold
    }
  },
  methods: {
    handleFacetSelection($event, id, key) {
      state.selectableFacets[id][key] = $event
      sessionStorage.setItem('lastFacetUsed', JSON.stringify({ type: FILTER_TYPES.facet, id: id }))
    },
    getHeadingText(specField) {
      const numberOfSelections = state.selectableFacets[specField.id].distinctValues.length
      return numberOfSelections > 0 ? `${specField.name} (${numberOfSelections})` : `${specField.name}`
    },
    getCheckboxText(specField, value) {
      return specField.unit ? `${value.value} ${specField.unit} (${value.count})` : `${value.value} (${value.count})`
    }
  }

}
</script>

<style lang="scss">
.filter-facet-selector__sections >*:not(:last-child){
  margin-bottom: measure(half);
  border-bottom: 1px solid color(border-gray) !important;

}

.filter-facet-selector__section-sub-title {
  @include body-smaller-bold;
  margin: 1rem 0;
}

.filter-facet-selector__section-filters >*:not(:last-child) {
  margin-bottom: measure(quarter);
}
</style>
